import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Container,
  LeftSection,
  ComposerButton,
  Airplane,
  Input,
  Label
} from '../Custom/MessageComposer';

const BannerComposer = () => {
  const { t } = useTranslation('full_page');

  return (
    <Container>
      <LeftSection htmlFor="banner-composer">
        <Label htmlFor="banner-composer">{t('banner_composer_label')}</Label>
        <Input id="banner-composer" disabled />
      </LeftSection>
      <ComposerButton aria-label={t('send_button_label')} disabled>
        <Airplane />
      </ComposerButton>
    </Container>
  );
};

export default BannerComposer;
